export default __webpack_public_path__ + "static/media/CNo.39-1.7ad66bdb.jpg";